import React from "react"
import { AppAffectedList, AppNote, AppValueChip, RentalDatesMultiPicker } from "@components"
import useReportMultipleModalMultipleEdit from "Pages/ReportsAlerts/Reports/@hooks/multipleModalActions/useEditMultiple"
import { useComputed } from "@preact/signals-react"
import { reportListMultipleData } from "Pages/ReportsAlerts/Reports/@signals"
import { formatDate } from "@ui-seeker/utils"
import { dateFormatReceiver } from "@utils"


export default function ReportMultiModalDateSection() {

	const { data, setData } = useReportMultipleModalMultipleEdit()

	return <>
		<AppNote severity="warning" sx={{ mb: 2.5 }}>
			This editor only works when the selected reports use <b>specific rental dates</b>.
		</AppNote>
		<RentalDatesMultiPicker
			value={data}
			onChange={e => setData(e)}
		/>
		<ReportMultiModalDatesDetails/>
	</>
}


function ReportMultiModalDatesDetails() {

	const reportsInfo = useComputed(() => reportListMultipleData.value.reportsInfo)

	return <AppAffectedList
		hint="current rental dates"
		rows={reportsInfo.value.map(({ name, specificDates }, idx) => ({
			key: `${name}-${idx}`,
			name,
			content: specificDates?.map((value, dateIdx) => <AppValueChip key={`${value}-${dateIdx}`}>
				{formatDate(value.split("T")[0], {
					receivedFormat: dateFormatReceiver(value.split("T")[0]),
					isString: true
				})}
			</AppValueChip>),
			aside: !specificDates && <AppValueChip tone="warning">Not affected — no specific dates</AppValueChip>,
		}))}
	/>
}
